<template>
  <svg
    viewBox="0 0 200 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-full w-full"
  >
    <!-- Back document - spreads left -->
    <g class="doc-left">
      <rect
        x="72"
        y="30"
        width="56"
        height="75"
        rx="3"
        fill="#ede9fe"
        stroke="#c4b5fd"
        stroke-width="1"
      />
      <rect x="82" y="45" width="28" height="2.5" rx="1" fill="#ddd6fe" />
      <rect x="82" y="53" width="36" height="2.5" rx="1" fill="#ddd6fe" />
      <rect x="82" y="61" width="32" height="2.5" rx="1" fill="#ddd6fe" />
    </g>

    <!-- Middle document - spreads right -->
    <g class="doc-right">
      <rect
        x="72"
        y="30"
        width="56"
        height="75"
        rx="3"
        fill="#f5f3ff"
        stroke="#a78bfa"
        stroke-width="1"
      />
      <rect x="82" y="45" width="28" height="2.5" rx="1" fill="#c4b5fd" />
      <rect x="82" y="53" width="36" height="2.5" rx="1" fill="#c4b5fd" />
      <rect x="82" y="61" width="32" height="2.5" rx="1" fill="#c4b5fd" />
    </g>

    <!-- Front document - stays centered -->
    <g>
      <rect
        x="72"
        y="30"
        width="56"
        height="75"
        rx="3"
        fill="#f5f3ff"
        stroke="#a78bfa"
        stroke-width="1"
      />
      <rect x="82" y="45" width="28" height="2.5" rx="1" fill="#a78bfa" />
      <rect x="82" y="53" width="36" height="2.5" rx="1" fill="#a78bfa" />
      <rect x="82" y="61" width="32" height="2.5" rx="1" fill="#a78bfa" />

      <!-- Checkmark badge -->
      <circle cx="118" cy="95" r="8" fill="#7c3aed" />
      <polyline
        points="114.5,95 117,97.5 121.5,92.5"
        stroke="white"
        stroke-width="1.75"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
      />
    </g>
  </svg>
</template>

<style scoped>
@keyframes spread-left {
  0%,
  100% {
    transform: rotate(0deg) translateX(0);
  }
  50% {
    transform: rotate(-8deg) translateX(-5px);
  }
}
@keyframes spread-right {
  0%,
  100% {
    transform: rotate(0deg) translateX(0);
  }
  50% {
    transform: rotate(8deg) translateX(5px);
  }
}
.doc-left {
  animation: spread-left 5s ease-in-out infinite;
  transform-origin: center bottom;
}
.doc-right {
  animation: spread-right 5s ease-in-out infinite 0.15s;
  transform-origin: center bottom;
}
</style>
